import React from 'react';
import { Label, Icon } from 'semantic-ui-react';

import classNames from 'classnames/bind';
import styles from './MyPageTitle.css';
const cx = classNames.bind(styles);

const MyPageTitle = ({ title, children, ...rest }) => (
  <div className={cx('mypage-title-box', { small: rest.small }, rest.templatePage)}>
    <div className={cx('page-title')}>{title}</div>
    {children && <div className={cx('page-func')}>{children}</div>}
  </div>
);

export default MyPageTitle;



// WEBPACK FOOTER //
// ./src/script/components/mypage/MyPageTitle.js